import { useSelector } from '@legendapp/state/react';
import { subscription$, fetchSubscription } from '../store/billing$';

/**
 * Hook to read subscription data from the app-level billing$ singleton.
 * All polling, Realtime, and visibilityChange logic lives in billing$.js —
 * this hook is a thin reactive reader with zero side effects.
 */
export function useSubscription() {
  const subscription = useSelector(() => subscription$.data.get());
  const loading = useSelector(() => subscription$.loading.get());
  const error = useSelector(() => subscription$.error.get());
  return { subscription, loading, error, refresh: fetchSubscription };
}
